import { render, staticRenderFns } from "./BikeInfo.vue?vue&type=template&id=65608c74&"
import script from "./BikeInfo.vue?vue&type=script&lang=js&"
export * from "./BikeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports